module.exports = __webpack_public_path__ + "static/media/um.eafc7245.svg";